export const DetailMenus = [
  {
    id: 'thong_tin_chung',
    label: 'Thông tin chung',
    icon: 'person-lines-fill',
    link: '/customer-support/account/{id}',
  },
  {
    id: 'lich_su_gan',
    label: 'Lịch sử gán NV',
    icon: 'list-check',
    link: '/customer-support/account/{id}/history-assign',
  },
  {
    id: 'lich_su_go_gan',
    label: 'Lịch sử gỡ gán NV',
    icon: 'list-check',
    link: '/customer-support/account/{id}/history-remove-assign',
  },
  {
    id: 'list_store',
    label: 'Danh sách cửa hàng',
    icon: 'shop',
    link: '/customer-support/store/?maId={maId}&maName={maName}',
  },
  {
    id: 'list_task',
    label: 'Danh sách công việc',
    icon: 'list-task',
    link: '/customer-support/task/?maId={maId}&maName={maName}',
  },
  {
    id: 'list_contact',
    label: 'Danh sách liên hệ',
    icon: 'phone',
    link: '/customer-support/contact/?maId={maId}&maName={maName}',
  },
]

export const asignType = {
  CVKD: 'CVKD',
  AS_ONLINE: 'AS Online',
  AS_OFFLINE: 'AS Offline',
  MANAGER_ASSIGNED: 'Cấp quản lý được giao chăm sóc',
  OTHER: 'Khác',
}
